module.exports = __webpack_public_path__ + "img/small-3.b5d8a3cf.jpg";